module.exports = __webpack_public_path__ + "img/Path 533.0087da8c.svg";